import React from 'react';
import { GlassCard } from './GlassCard';
import { ProgressBar } from './ProgressBar';
import { Goal } from '../hooks/useGoals';
import { useNavigate } from 'react-router-dom';
interface GoalCardProps {
  goal: Goal;
  progress: number;
  dailyTarget: number;
}
export function GoalCard({
  goal,
  progress,
  dailyTarget
}: GoalCardProps) {
  const navigate = useNavigate();
  const isComplete = progress >= 100;
  return <GlassCard className="p-6 cursor-pointer hover:scale-105 transition-transform duration-300" data-id="element-42">
      <div onClick={() => navigate(`/goal/${goal.id}`)} data-id="element-43">
        <div className="flex items-start justify-between mb-4" data-id="element-44">
          <div data-id="element-45">
            <h3 className="text-xl font-semibold text-white mb-1" data-id="element-46">
              {goal.name}
            </h3>
            <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 text-sm text-white" data-id="element-47">
              {goal.type === 'debt' ? 'Debt 💸' : 'Savings 💰'}
            </span>
          </div>
          {isComplete && <span className="text-2xl" data-id="element-48">🎉</span>}
        </div>

        <div className="space-y-3" data-id="element-49">
          <ProgressBar progress={progress} data-id="element-50" />

          <div className="flex justify-between text-sm text-white/80" data-id="element-51">
            <span data-id="element-52">${goal.currentAmount.toLocaleString()}</span>
            <span data-id="element-53">${goal.targetAmount.toLocaleString()}</span>
          </div>

          {!isComplete && <div className="pt-2 border-t border-white/20" data-id="element-54">
              <p className="text-sm text-white/70" data-id="element-55">Daily target</p>
              <p className="text-2xl font-bold text-white" data-id="element-56">
                ${dailyTarget.toFixed(2)}
              </p>
            </div>}
        </div>
      </div>
    </GlassCard>;
}